import { render } from "./MobileScanView.vue?vue&type=template&id=bfada7c2&scoped=true"
import script from "./MobileScanView.vue?vue&type=script&lang=js"
export * from "./MobileScanView.vue?vue&type=script&lang=js"

import "./MobileScanView.vue?vue&type=style&index=0&id=bfada7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfada7c2"]])

export default __exports__